module.exports = "pegasus/assets/circleline-twitter.gif";